<template>
    <div class="right-box">
        <Title :title="dszk"/>

        <div class="cheked">
            <el-checkbox v-model="checked" disabled>快评</el-checkbox>
            <el-checkbox v-model="checked" disabled>报告</el-checkbox>
            <el-checkbox v-model="checked" disabled>专题</el-checkbox>
            <el-checkbox v-model="checked" disabled>原创</el-checkbox>
            <el-checkbox v-model="checked" disabled>数据</el-checkbox>
        </div>

        <form role="form" action="/emailadd.html" method="post" class="form">
            <input type="email" class="form-control" id="email" name="email" placeholder="请输入您的邮箱">
            <button type="submit" class="btn">邮箱订阅</button>
        </form>

        <ul class="right-list">
            <li
            v-for="(item, index) in list"
            :key="index">
                <Title :title="item.title"/>

                <div class="right-main">
                    <el-link
                    :href="item.url"
                    target="_blank"
                    :underline="false">
                        <img
                        :src="item.img"
                        lazy>
                    </el-link>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Rightbox',
    data() {
        return {
            dszk: {
                topic: '电商周刊',
                more: {
                    name: '我要订阅',
                    url: '/zt/dszk/'
                }
            },
            list: [
                {
                    title: {
                        topic: '产品服务',
                        more: {
                            name: '我要采购',
                            url: '/Index/Wjsproviders.html'
                        }
                    },
                    img: '/Public/home/images/wjsviders/550.gif'
                },
                {
                    title: {
                        topic: '电数宝',
                        more: {
                            name: '我要数据',
                            url: '/Index/dsb_product.html'
                        }
                    },
                    img: '/Public/home/images/dsb550.gif'
                },
                {
                    title: {
                        topic: '电融宝',
                        more: {
                            name: '我要融资',
                            url: '/Index/finance.html'
                        }
                    },
                    img: '/Public/home/images/drb550.gif'
                },
                {
                    title: {
                        topic: '电诉宝',
                        more: {
                            name: '我要投诉',
                            url: '/Index/complain.html'
                        }
                    },
                    img: '/Public/home/images/tsb550.gif'
                },
                {
                    title: {
                        topic: '报告库',
                        more: {
                            name: '我要定制',
                            url: '/zt/Wjsreport/'
                        }
                    },
                    img: '/zt/upload_data/Wjsreport/images/550.gif'
                },
                {
                    title: {
                        topic: '品牌栏目',
                        more: {
                            name: '查看更多',
                            url: '/zt/pplm/'
                        }
                    },
                    img: '/Public/home/images/pplm550.gif'
                },
            ],
            checked: true
        }
    }
}
</script>

<style scoped>
.right-box {
    width: 260px;
    margin-left: 50px;
}

.right-box .cheked {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
}

.right-box .el-checkbox {
    margin-right: 0px;
}

.right-box .form {
    display: flex;
}

.right-box .form .btn {
    color: dodgerblue;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
    border: 1px solid #dcdfe6;
    cursor: pointer;
    transition: all .3s ease;
}

.right-box .form .btn:hover {
    color: #fff;
    background-color: dodgerblue;
    border-color: dodgerblue;
}

.right-box .form input {
    flex: 1;
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: 12px;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
}

.right-list li {
    margin-top: 10px;
}

.right-list img {
    width: 100%;
    border-radius: 4px
}

@media(max-width: 1100px) {
    .right-box {
        width: 90%;
        margin: auto;
    }

    .right-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 20px;
    }

    .right-list li {
        flex: 0 0 49%;
    }
}
</style>
